import React, { useState, useEffect } from "react";
import "./customStyle.css";
import AcceptRequestDialog from "./Dialouge";
import apiServices from "../../services/apiServices";
import CustomizedSnackbars from "./CustomSnackbar";
import ChatHeader from "./components/ChatComponents/ChatHeader";
import ChatMessages from "./components/ChatComponents/ChatMessages";
import ChatInput from "./components/ChatComponents/ChatInput";

const ChatComponent = React.memo((props) => {
  const {
    selectedChat,
    accept,
    sender,
    receiver,
    callResponse,
    setChattingContactApi,
    setPopup,
    popUp,
  } = props;

  const [imageModal, setImageModal] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [reportReason, setReportReason] = useState("");
  const [inputMessage, setInputMessage] = useState("");
  const [popUpBlock, setPopupBlock] = useState(false);
  const [reportUser, setReportUser] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const open = Boolean(anchorEl);
  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const [menuAnchor, setMenuAnchor] = useState(null); // Renamed from anchorEl
  const [isOpenMenuType, setIsOpenMenuType] = useState(null);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const updateSnackbar = ({ message = "", severity = "", open = false }) => {
    setSnackbarState({
      message: message,
      severity: severity,
      open: open,
    });
  };
  const handleSnackbarClose = () => {
    setSnackbarState({
      message: "",
      severity: "",
      open: false,
    });
  };
  const closeMenu = () => {
    setMenuAnchor(null); // Renamed from setAnchorEl
    setIsOpenMenuType(null);
  };
  useEffect(() => {
    let interval;
    let isRunning = false;
    if (isRecording && !isRunning) {
      isRunning = true;
      // interval = setInterval(() => {
      //   setSecondsElapsed((prevSeconds) => {
      //     return prevSeconds + 1;
      //   });
      // }, 1000);
    }
    return () => {
      clearInterval(interval);
      isRunning = false;
    };
  }, [isRecording]);

  const hours = Math.floor(secondsElapsed / 3600);
  const minutes = Math.floor((secondsElapsed % 3600) / 60);
  const seconds = secondsElapsed % 60;

  // Format time for display
  const formattedTime = [hours, minutes, seconds]
    .map((v) => (v < 10 ? "0" + v : v))
    .join(":");

  useEffect(() => {
    renderMediaContent(inputMessage);
  }, [inputMessage]);

  let mediaRecorder;

  // const handleAccept = async () => {
  //   let obj = {
  //     requestedBy: accept?.requestedBy, //Accepting user Id
  //     conversationId: accept?.conversationId,
  //   };

  //   let response = await apiServices.acceptRequest(obj);
  //   console.log("respponse", response);
  //   if (response?.status == 200) {
  //     // alert(response?.data?.message);
  //     setPopup(false);
  //   } else {
  //     // alert(response?.data?.message);
  //   }
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseUser = () => {
    setAnchorElUser(null);
  };

  // useEffect(() => {
  //   handleSendClick();
  // }, [inputMessage]);

  const renderMessageWithLinks = (text) => {
    const words = text.split(" ");

    return words.map((word, index) => {
      const isImageURL = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(word);

      if (isImageURL) {
        return <img key={index} src={word} alt="Image" />;
      } else {
        return <span key={index}>{word} </span>;
      }
    });
  };

  const zoomImage = (e) => {
    setImageModal(true);
    setImageUrl(e);
  };

  const renderMediaContent = (text) => {
    const isImageURL = /\.(gif|jpe?g|tiff?|png|webp|bmp)-\d+(\?.*)?$/i.test(
      text
    );
    const isVideoURL = /\.(mp4|webm|MOV|ogg)-\d+(\?.*)?$/i.test(text);
    const isAudioURL = /\.(mp3|wav)-\d+(\?.*)?$/i.test(text);
    const isFileURL = /\/[^/.]+\.\w+-\d+(\?.*)?$/i.test(text);

    const handleImageClick = () => {
      const anchor = document.createElement("a");
      anchor.href = text;
      anchor.download = text.split("/").pop();
      anchor.click();
    };

    if (isImageURL) {
      return (
        <img
          style={{ width: "100%", height: "120px", borderRadius: "10px" }}
          src={text}
          alt="Image"
          onClick={(e) => zoomImage(text)}
        />
      );
    } else if (isVideoURL) {
      return (
        <video controls style={{ width: "200px", height: "120px" }}>
          <source src={text} />
          Your browser does not support the video tag.
        </video>
      );
    } else if (isAudioURL) {
      return (
        <audio controls src={text}>
          Your browser does not support the audio tag.
        </audio>

        // </audio>
        //   <audio controls>
        //     <source src={text} type={`audio/${text.split(".").pop()}`} />
        //     Your browser does not support the audio tag.
        //   </audio>
      );
    } else if (isFileURL) {
      return (
        <div>
          <img
            style={{ width: "100%", height: "80px", borderRadius: "10px" }}
            onClick={handleImageClick}
            src={
              process.env.REACT_APP_PUBLIC_URL +
              "/BuzzCom/images/filesample.jpg"
            }
            alt="File Thumbnail"
          />
          {/* <a href={text} download={text.split('/').pop()}>{text.split('/').pop()}</a>
        <p>File - {text.split('.').pop()}</p> */}
        </div>
      );
    } else {
      return (
        <div style={{ lineHeight: "20px" }}>
          {text?.length > 80 ? (
            <div>
              {text.substring(0, 80)}
              <br />
              {Array.from(
                { length: Math.ceil((text?.length - 80) / 80) },
                (_, index) => (
                  <div key={index}>
                    {text.substring(80 + index * 80, 80 + (index + 1) * 80)}
                    <br />
                  </div>
                )
              )}
            </div>
          ) : (
            text
          )}
        </div>
      );
    }
  };

  // useEffect(() => {
  //   setSelectedChat(selectedChat);
  // }, [contacts]);

  return (
    <div
      className="borders"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "none",
      }}
    >
      <CustomizedSnackbars
        open={snackbarState.open}
        message={snackbarState.message}
        severity={snackbarState.severity}
        onClose={handleSnackbarClose}
      />{" "}
      <ChatHeader />
      <ChatMessages />
      <ChatInput updateSnackbar={updateSnackbar} />
      {/* </Paper> */}
      {/* <AcceptRequestDialog
        cancelText="Cancel"
        acceptText="Accept"
        title="Accept Contact Request"
        text=" You have received a contact request. Do you want to accept it?"
        open={popUp}
        onClose={() => setPopup(false)}
        onAccept={handleAccept}
      /> */}
      {/* <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List>
          {!hideEdit && (
            <ListItem button onClick={handleEdit}>
              <ListItemText primary="Edit" />
            </ListItem>
          )}
          <ListItem button onClick={handleDelete}>
            <ListItemText primary="Delete" />
          </ListItem>
        </List>
      </Popover> */}
    </div>
  );
});

export default ChatComponent;
